import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import Button from "../../../components/button";
import { isFileValid, isImageValid } from "../../../utils/helper";
import Localization from "../../../localization";

const FileStep = ({ stepId, step, formik, initialFile, image = false }) => {
    const locale = useSelector((state) => state.app.locale);
    const ref = useRef();

    const [files, setFiles] = useState([]);

    useEffect(() => {
        if (initialFile) {
            _addFile(initialFile);
        }
    }, [initialFile]);

    const _addFile = async (event) => {
        if (image) {
            const result = await isImageValid(event);
            if (!result.size) {
                alert(Localization[locale].register.step_9_photo_size);
                return;
            } else if (!result.resolution) {
                alert(Localization[locale].register.step_9_photo_resolution);
                return;
            }
        } else {
            const result = await isFileValid(event);
            if (!result.size) {
                alert(Localization[locale].register.step_9_photo_size);
                return;
            }
        }

        let files = [];
        files.push(event);
        formik.setFieldValue(stepId, files[0]);
        setFiles(files);
    };

    const _removeFile = (image) => {
        let newFiles = files.slice();

        newFiles = newFiles.filter((item) => item !== image);

        formik.setFieldValue(stepId, null);

        setFiles(newFiles);
    };

    const _renderFile = () => {
        if (files.length > 0) {
            return files.map((file) => {
                if (image) {
                    return (
                        <div
                            className="w-70 h-70 cursor-pointer"
                            onClick={() => {
                                _removeFile(file);
                            }}
                        >
                            <img
                                src={URL.createObjectURL(file)}
                                className="border rounded w-70 h-70"
                            />
                        </div>
                    );
                }
                return (
                    <div
                        key={file.name}
                        className="cursor-pointer"
                        onClick={() => {
                            _removeFile(file);
                        }}
                    >
                        <p>{file.name}</p>
                    </div>
                );
            });
        }

        return null;
    };

    return (
        <div>
            <div className="flex">{_renderFile()}</div>
            <div className="w-208 mt-10">
                <Button
                    text={step.name}
                    textStyle="font-bold text-17 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                    backgroundColor="bg-grey"
                    onClick={() => {
                        ref.current.click();
                    }}
                    wrapperStyle="px-20"
                />
            </div>

            {formik.touched[stepId] && formik.errors[stepId] && (
                <p className="text-red text-12 mt-6">{formik.errors[stepId]}</p>
            )}

            {step.help && <p className="text-14 mt-6">{step.help}</p>}

            <input
                type="file"
                ref={ref}
                className="hidden"
                onChange={(event) => {
                    _addFile(event.target.files[0]);
                }}
                accept="image/jpeg,image/png,application/pdf"
            />
        </div>
    );
};

export default FileStep;
